import AirpodsIcon from '@/assets/icons/airpods4.png'
import reward1Icon from '@/assets/icons/reward-1.png'
import reward2Icon from '@/assets/icons/reward-2.png'
import reward3Icon from '@/assets/icons/reward-3.png'

import { SectionTitle } from '../../components/shared/styles'

import JackpotItem from './components/JackpotItem'
import PrizeTier from './components/PrizeTier'
import { Container, ContentWrapper, TierRow } from './styles'

const PRIZE_TIERS = [
  { imageSrc: reward1Icon, rank: '2등', amount: '10,000원' },
  { imageSrc: reward2Icon, rank: '3등', amount: '2,000원' },
  { imageSrc: reward2Icon, rank: '4등', amount: '1,000원' },
  { imageSrc: reward3Icon, rank: '5등', amount: '700원' },
] as const

export default function RewardSection() {
  return (
    <Container>
      <SectionTitle>당첨 혜택</SectionTitle>
      <ContentWrapper>
        <JackpotItem imageSrc={AirpodsIcon} badgeLabel='1등' productName='Apple Airpods 4세대' />
        <TierRow>
          {PRIZE_TIERS.map((tier) => (
            <PrizeTier key={tier.rank} imageSrc={tier.imageSrc} rank={tier.rank} amount={tier.amount} />
          ))}
        </TierRow>
      </ContentWrapper>
    </Container>
  )
}
